export function isValidLongitude(value: number): boolean {
    return typeof value === "number" && Math.abs(value) <= 180;
}

export function isValidLatitude(value: number): boolean {
    return typeof value === "number" && Math.abs(value) <= 90;
}

/** A box around a point, for zooming the map to a single point. Returned as [west, south, east, north] */
export function getBoundsAroundPoint(lng: number, lat: number, paddingDegrees: number): [number, number, number, number] {
    return [lng - paddingDegrees, lat - paddingDegrees, lng + paddingDegrees, lat + paddingDegrees];
}

/** How wide an area given as [west, south, east, north] is in degrees of longitude. It crosses the antimeridian when its west edge is east of its east edge */
export function getLongitudeWidth([west, , east]: [number, number, number, number]): number {
    return east >= west ? east - west : east - west + 360;
}

/** A longitude moved a whole number of turns round the world to the first place at or east of the given west edge, so places either side of the antimeridian are next to each other */
export function unwrapLongitude(lng: number, west: number): number {
    return ((((lng - west) % 360) + 360) % 360) + west;
}

/** Whether a point is within an area given as [west, south, east, north], including one crossing the antimeridian or numbered past 180 */
export function isPointInBounds([lng, lat]: [number, number], bounds: [number, number, number, number]): boolean {
    const [west, south, , north] = bounds;
    return unwrapLongitude(lng, west) - west <= getLongitudeWidth(bounds) && lat >= south && lat <= north;
}
